import { render } from "./ApplicationLogo.vue?vue&type=template&id=61ea707a"
const script = {}

import exportComponent from "/Users/ruisilva/Desktop/Projects/qmulher/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__